<template>
  <b-row>
    <b-col>
      <b-row v-for="(item, itemIndex) in items" v-bind:key="'task-' + taskIndex + '-item-' + itemIndex">
        <b-col cols="12" v-if="itemIndex !== 0">
          <hr class="mt-1 mb-1">
        </b-col>
        <b-col cols="12">
          <div>
            <b-badge v-if="item.holded" variant="warning">{{ $t('global.held') }}</b-badge>
            <b-badge v-else-if="!item.dateStart && !item.dateStop" variant="success">{{ $t('global.notStarted') }}</b-badge>
            <b-badge v-else-if="item.dateStart && !item.dateStop" variant="success">{{ $t('global.processing') }}</b-badge>
            <b-badge v-else-if="item.dateStart && item.dateStop" variant="success">{{ $t('global.over') }}</b-badge>
          </div>
          <div>
            <small>{{ item.idUserData.name }} {{ item.idUserData.surname }}</small><br>
            <small>{{ $t('global.day') }}: {{ $moment(item.date).format('YYYY-MM-DD') }}</small><br>
            <small v-if="item.dateStart">{{ $t('global.started') }}: {{ $moment(item.dateStart).format('HH:mm:ss') }}</small><br v-if="item.dateStart">
            <small v-if="item.dateStop">{{ $t('global.finished') }}: {{ $moment(item.dateStop).format('HH:mm:ss') }}</small><br v-if="item.dateStop">
          </div>
          <div>
            <router-link :to="{ name: 'DailyPlanShow', params: { date: $moment(item.date).format('YYYY-MM-DD'), idServiceman: item.idUserData['@id'] }}" class="mt-1 btn btn-sm btn-default btn-block">{{$t('buttons.goToDailyPlan')}}</router-link>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'TaskHistory',
  props: {
    taskIndex: {
      type: Number,
      required: true
    },
    items: {
      type: Array,
      default: () => {
        return []
      }
    }
  }
}
</script>
